// Páginas públicas com editor visual de conteúdo — usado no seletor "Editar outra página"
// dentro de cada *VisualEditor.jsx. Adicionar aqui quando uma nova página ganhar editor (ex.: Blog).
export const EDITABLE_PAGES = [
  { label: "Página Inicial", path: "/admin/conteudo-inicio" },
  { label: "Página Sobre", path: "/admin/conteudo-sobre" },
  { label: "Página Contacto", path: "/admin/conteudo-contacto" },
  { label: "Página Blog", path: "/admin/conteudo-blog" },
  { label: "Rodapé", path: "/admin/conteudo-rodape" },
];
